export const MAX_ZOOM = 20;
export const MAX_ANNOTATION_ZOOM = 5;
export const MIN_ZOOM = 1;
